import { useSelector } from 'react-redux';
import { Alert } from '@mui/material';
import type { RootState} from '../types/store.tsx';

type UIErrorProps = {
    message: string|number|null;
}

export default function UIError({message} : UIErrorProps) {
    const errors = useSelector((state:RootState) => state.ui.language.errors);

    let msg:string = "";
    if(message != null)
    {
        if(typeof message === 'number')
        {
            if (errors[message] !== undefined)
                msg = errors[message];
            else
                msg = `Unknown error: ${message}`
        }
        else
        {
            msg = message;
        }
    }
        
    return(<Alert severity="error" sx={{visibility: msg.length === 0 ? "hidden" : "visible" }}>{msg}</Alert>);

}